const MAPS = {
  referral: {
    "New": "bg-brand-teal/10 text-brand-teal",
    "Under Review": "bg-amber-100 text-amber-800",
    "Contacted": "bg-blue-100 text-blue-800",
    "Assessment Scheduled": "bg-indigo-100 text-indigo-800",
    "Accepted": "bg-green-100 text-green-800",
    "Converted to Patient": "bg-brand-navy/10 text-brand-navy",
    "Declined": "bg-red-100 text-red-700",
    "Closed": "bg-slate-200 text-slate-600",
  },
  visit: {
    "Upcoming": "bg-blue-100 text-blue-800",
    "In Progress": "bg-amber-100 text-amber-800",
    "Completed": "bg-green-100 text-green-800",
    "Cancelled": "bg-red-100 text-red-700",
  },
  patient: {
    "Active": "bg-green-100 text-green-800",
    "Pending": "bg-amber-100 text-amber-800",
    "On Hold": "bg-orange-100 text-orange-800",
    "Inactive": "bg-slate-200 text-slate-600",
    "Closed": "bg-brand-navy/10 text-brand-navy",
  },
  caregiver: {
    "Active": "bg-green-100 text-green-800",
    "Available": "bg-brand-teal/10 text-brand-teal",
    "Assigned": "bg-blue-100 text-blue-800",
    "Unavailable": "bg-amber-100 text-amber-800",
    "Inactive": "bg-slate-200 text-slate-600",
  },
};

export const Badge = ({ kind, value }) => (
  <span className={`inline-flex items-center rounded-full px-3 py-1 text-xs font-bold whitespace-nowrap ${MAPS[kind]?.[value] || "bg-slate-200 text-slate-600"}`}>
    {value}
  </span>
);
